module.exports = __webpack_public_path__ + "img/open_weapon.b77fb22c.png";